// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.elt-wp-plugin {
  margin: 2em auto;
}

.cp_ipselect_label {
  margin-bottom: 0.5em;
  font-size: 1.6rem;
  color: #2a3d86;
  text-align: left;
}

.button-list {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.button-item {
  position: relative;
  padding: 0.8rem 1.2rem;
  font-size: 1.4rem;
  background-color: #fff;
  color: #2a3d86;
  cursor: pointer;
  transition: background-color 0.3s, color 0.3s;
  z-index: 1;
  overflow: hidden;
  border-radius: 0.25rem;
  border: 0.1rem solid transparent; /* グラデーション適用の準備 */
  background-image: linear-gradient(white, white), linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8); /* 背景に2つのグラデーションを設定 */
  background-origin: border-box;
  background-clip: padding-box, border-box;
}

.button-item::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);
  z-index: -1;
  opacity: 0;
  transition: opacity 0.3s;
}

.button-item.selected::before {
  opacity: 1;
}

.button-item.selected {
  color: #fff;
  font-weight: bold !important; /* フォントの太さを強制適用 */
  background-image: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8) !important; /* 背景グラデーションを適用 */
  border: 0.1rem solid transparent; /* グラデーション適用の準備 */
  background-image: linear-gradient(white, white), linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8); /* 背景に2つのグラデーションを設定 */
}

.button-item:hover::before {
  opacity: 0.1;
}

.cp_ipselect_message {
  font-size: 1.4rem;
  color: #666;
}

.contact-link {
  color: #2589d0;
  text-decoration: underline;
}

.contact-link:hover {
  color: #1a6ca7;
}

.selected-course-and-label {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
}

.selected-course {
  background-color: #F4F4F4;
  font-size: 1.2rem;
  margin-left: 1rem;
  padding: 0.5rem 1rem;
}


`, "",{"version":3,"sources":["webpack://./src/styles/PlanButtonSelector.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;EACjB,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,6CAA6C;EAC7C,UAAU;EACV,gBAAgB;EAChB,sBAAsB;EACtB,gCAAgC,EAAE,iBAAiB;EACnD,kGAAkG,EAAE,qBAAqB;EACzH,6BAA6B;EAC7B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,6DAA6D;EAC7D,WAAW;EACX,UAAU;EACV,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,4BAA4B,EAAE,iBAAiB;EAC/C,8EAA8E,EAAE,iBAAiB;EACjG,gCAAgC,EAAE,iBAAiB;EACnD,kGAAkG,EAAE,qBAAqB;AAC3H;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,0BAA0B;AAC5B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,iBAAiB;EACjB,iBAAiB;EACjB,oBAAoB;AACtB","sourcesContent":[".elt-wp-plugin {\n  margin: 2em auto;\n}\n\n.cp_ipselect_label {\n  margin-bottom: 0.5em;\n  font-size: 1.6rem;\n  color: #2a3d86;\n  text-align: left;\n}\n\n.button-list {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.button-item {\n  position: relative;\n  padding: 0.8rem 1.2rem;\n  font-size: 1.4rem;\n  background-color: #fff;\n  color: #2a3d86;\n  cursor: pointer;\n  transition: background-color 0.3s, color 0.3s;\n  z-index: 1;\n  overflow: hidden;\n  border-radius: 0.25rem;\n  border: 0.1rem solid transparent; /* グラデーション適用の準備 */\n  background-image: linear-gradient(white, white), linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8); /* 背景に2つのグラデーションを設定 */\n  background-origin: border-box;\n  background-clip: padding-box, border-box;\n}\n\n.button-item::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8);\n  z-index: -1;\n  opacity: 0;\n  transition: opacity 0.3s;\n}\n\n.button-item.selected::before {\n  opacity: 1;\n}\n\n.button-item.selected {\n  color: #fff;\n  font-weight: bold !important; /* フォントの太さを強制適用 */\n  background-image: linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8) !important; /* 背景グラデーションを適用 */\n  border: 0.1rem solid transparent; /* グラデーション適用の準備 */\n  background-image: linear-gradient(white, white), linear-gradient(90deg, #2a3d86, #4a5db6, #7a9fd8); /* 背景に2つのグラデーションを設定 */\n}\n\n.button-item:hover::before {\n  opacity: 0.1;\n}\n\n.cp_ipselect_message {\n  font-size: 1.4rem;\n  color: #666;\n}\n\n.contact-link {\n  color: #2589d0;\n  text-decoration: underline;\n}\n\n.contact-link:hover {\n  color: #1a6ca7;\n}\n\n.selected-course-and-label {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n}\n\n.selected-course {\n  background-color: #F4F4F4;\n  font-size: 1.2rem;\n  margin-left: 1rem;\n  padding: 0.5rem 1rem;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
